<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vx-card>
        <div>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="vouchers"
            :description="false"
            search
            @selected="handleSelected"
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.FeeMaster") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Fee Master' })"
                  size="small"
                  >{{ $t("setup.label.CreateFeeMaster") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.FeeMasterCode") }}</vs-th>
              <vs-th>{{ $t("setup.label.FeeMasterDescription") }}</vs-th>
              <vs-th>{{ $t("setup.label.FeeMasterTransactionType") }}</vs-th>
              <vs-th>{{ $t("setup.label.ChargeCode") }}</vs-th>

              <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="vouchers"
                v-for="(vouchers, index) in data"
              >
                <vs-td :data="vouchers.feeCode">{{ vouchers.feeCode }}</vs-td>
                <vs-td :data="vouchers.feeDescription">{{
                  vouchers.feeDescription
                }}</vs-td>
                <vs-td :data="vouchers.transactionType">{{
                  vouchers.transactionType
                }}</vs-td>
                <vs-td :data="vouchers.chargeCode">{{
                  vouchers.chargeCode
                }}</vs-td>

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EyeIcon"
                      :title="$t('setup.label.View')"
                      svgClasses="w-5 h-5 stroke-current cursor text-primary"
                      @click.stop="handleSelected(vouchers)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="EditFeemaster(vouchers.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="
                        deletefeemasterPopup = true;
                        delId = vouchers.id;
                      "
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deletefeemasterPopup"
      :title="$t('setup.label.FeeMaster')"
      @deletePressed="deletefeemaster(delId)"
      @cancelPressed="deletefeemasterPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      voucher: [],
      deletefeemasterPopup: false,
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapState({
      vouchers: (state) => state.feeMaster.ListFeeMaster,
    }),
  },
  methods: {
    getListFeemaster() {
      this.loading = true;
      this.$store.dispatch("feeMaster/setListFeemaster");
      this.voucher = this.vouchers;
      this.loading = false;
    },
    async deletefeemaster(id) {
      this.deletefeemasterPopup = false;
      try {
        await this.$store.dispatch("feeMaster/deletefeemasterAction", id);
        await this.getListFeemaster();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Fee Master Deleted Successfully!",
          type: "success",
        });
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: error.message,
          type: "error",
        });
      }
    },
    handleSelected(vouchers) {
      this.$router.push({ name: "View Fee", params: { id: vouchers.id } });
    },
    EditFeemaster(id) {
      this.$router.push({ name: "Edit Fee Master", params: { id: id } });
    },
  },
  mounted() {
    this.getListFeemaster();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
